import React from "react";
import PropTypes from "prop-types";
import { Container } from "shards-react";
import { useAuth } from "../providers/AuthProvider";
import { Redirect } from "react-router-dom";

const DefaultLayout = ({ children, noNavbar, noFooter }) => {
  const { currentUser } = useAuth();
  // const { token } = useAuth();
  return (
    <Container>
      {!currentUser ? children : <Redirect to="/" />}
    </Container>
  )
};

DefaultLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

DefaultLayout.defaultProps = {
  noNavbar: true,
  noFooter: true
};

export default DefaultLayout;
